import { render, staticRenderFns } from "./ModalTesterPage.vue?vue&type=template&id=e3a70656&"
import script from "./ModalTesterPage.vue?vue&type=script&lang=js&"
export * from "./ModalTesterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports